const validateSameDate = (start, end) => {
	const isSameDate = start.toDateString() === end.toDateString();

	return isSameDate;
};

export default validateSameDate;
